import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export function useAnalysesQuery() {
  const q = useQuery({
    queryKey: ['analyses'],
    queryFn: async () => {
      const data = await fetch(
        `/analysis`,
        { method: 'GET' },
        schemas.AnalysesDto
      );
      return data;
    },
    retry: false,
    refetchInterval: 5000
  });

  return q;
}
